import React from 'react';
import PropTypes from 'prop-types';

function Customize({ size, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <path d="M16.6667 12L8.69949 4L4 8.68815L11.9314 16.7195" />
      <path d="M25.3715 9.99287L28 7.36501L24.6374 4L22.0089 6.62744M10.0363 25.3235L25.3715 9.99287L22.0089 6.62744L6.67421 21.9585L4 28L10.0363 25.3235V25.3235Z" />
      <path d="M20.7654 25.2557L23.0491 22.9828M9.28639 13.7954L11.8023 11.2913M18.2565 22.7897L20.1272 20.9289M6.66699 11.1693L8.51312 9.33333M15.3337 20L23.4521 28L28.0003 23.4751L19.854 15.5103L15.3337 20Z" />
      <path d="M6.66699 22L10.0003 25.3333" />
    </svg>
  );
}

Customize.propTypes = {
  stroke: PropTypes.string.isRequired,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default Customize;
